import React from 'react';
import styled from 'styled-components';
import { P2, P4 } from 'styleguide/Texts';
import { StatProps } from '../types';
import { ColoredIcon } from 'styleguide/Icons';
import { Spacing } from 'styleguide/spacing';
import { FlexRow } from 'styleguide/Row';
import { View } from 'styleguide/View';

const StatContainer = styled(View)`
  margin-inline-end: ${2 * Spacing.md}px;
`;

const Stat = ({ title, value, isPr }: StatProps) => {
  return (
    <StatContainer>
      <P4 type="secondary">{title}</P4>
      {isPr ? (
        <FlexRow>
          <ColoredIcon
            type={'pr'}
            style={{ height: Spacing.md, width: Spacing.md, paddingInlineEnd: Spacing.xs }}
          />
          <P2>{value}</P2>
        </FlexRow>
      ) : (
        <P2>{value}</P2>
      )}
    </StatContainer>
  );
};

const Container = styled.div`
  display: flex;
`;

interface Props {
  stats: StatProps[];
}

export const Stats = ({ stats }: Props) => {
  return (
    <Container>
      {stats.map(s => (
        <Stat key={s.title} {...s} />
      ))}
    </Container>
  );
};
